import api from 'api';

const basePath = (establishmentSlug) => `establishments/${establishmentSlug}/reservations`;

// Laravel JsonResource wraps every response in a `data` envelope by default
// ({"data": [...]} for collections, {"data": {...}} for a single resource).
const unwrapList = (data) => Array.isArray(data) ? data : (data?.data ?? []);
const unwrapItem = (data) => data?.data ?? data;

export const getReservations = async (establishmentSlug) => {
    const { data } = await api().get(basePath(establishmentSlug));
    return unwrapList(data);
};

// Public endpoint (no auth) so visitors can browse availability before logging in.
// `days` maps YYYY-MM-DD -> ["HH:mm", ...]; days without slots are omitted.
export const getReservationAvailability = async (establishmentSlug, { month, partySize }) => {
    const params = { month };
    if (partySize) params.party_size = partySize;
    const { data } = await api(undefined, true).get(`${basePath(establishmentSlug)}/availability`, { params });
    return unwrapItem(data);
};

export const createReservation =async (establishmentSlug, payload) => {
    const { data } = await api().post(basePath(establishmentSlug), payload);
    return unwrapItem(data);
};

export const updateReservation = async (establishmentSlug, reservationId, payload) => {
    const { data } = await api().put(`${basePath(establishmentSlug)}/${reservationId}`, payload);
    return unwrapItem(data);
};

export const getMyReservations = async () => {
    const { data } = await api().get('users/reservations');
    return unwrapList(data);
};

export const cancelMyReservation = async (reservationId, cancelReason) => {
    const { data } = await api().put(`users/reservations/${reservationId}/cancel`, cancelReason ? { cancel_reason: cancelReason } : {});
    return unwrapItem(data);
};

export const getReservationSettings = async (establishmentSlug) => {
    const { data } = await api().get(`${basePath(establishmentSlug)}/settings`);
    return unwrapItem(data);
};

// `settings`: { max_party_size_per_slot, max_party_size, slot_interval_minutes } — each nullable.
export const updateReservationSettings = async (establishmentSlug, settings) => {
    const { data } = await api().put(`${basePath(establishmentSlug)}/settings`, settings);
    return unwrapItem(data);
};
